// VolView nằm trong iframe trang DicomView của RIS: mọi tin gửi lên trang cha đi qua đây.

// Nguồn trang cha để postMessage đúng người nhận; trình duyệt không cho biết thì đành '*' (tin không mang ảnh).
export function nguonCha(win: Window = window): string {
  const theoTrinhDuyet = win.location.ancestorOrigins?.[0];
  if (theoTrinhDuyet) return theoTrinhDuyet;
  try {
    return win.document.referrer ? new URL(win.document.referrer).origin : '*';
  } catch {
    return '*';
  }
}

// data gộp thẳng vào tin: viewer-error mang {message}, viewer-progress mang {percent,loaded,total}.
export function baoTrangCha(
  type: string,
  data?: Record<string, unknown>,
  win: Window = window
) {
  if (win.parent === win) return;
  try {
    win.parent.postMessage({ type, ...data }, nguonCha(win));
  } catch {
    /* trang cha đã đi nơi khác */
  }
}
